import { ProjectBase } from '../components/ProjectBase';
import { ProjectInterface } from '../pages/Projects';
import { ProjectType } from "src/components/ProjectType";

import cover from "../assets/img/gdstd1.webp";
import { Col } from 'react-bootstrap';
import { renderTextBlock } from 'src/components/RenderTextBlocks';


export const projectDetails: ProjectInterface = {
    url: "gdstd1",
    title: "Gamedev Study 1",
    summary: "Small prototype to test and study Unity's URP and TPS controlling.",
    description: `Since my last project was a FPS and was also a kind of big one, I wanted to do a small project just to test TPS controlling and Unity's URP.`,
    year: "2021",
    tags: ["TPS", "Prototype", "Study Project", "Unity"],
    imageSrc: cover,
    hasVideo: false,
    startVideoTime: 0,
    videoSrc: "",
    isCoverType: true,
    haveTags: true,
    projectType: ProjectType.STUDY,
    roles: ["Programmer", "Study"],
    technologies: ["Unity", "C#", "URP"],
    collaborators: ["Lucas Coutinho"],
    highlightColor: "#60151F",
    descriptionTitle: "A short break from big projects",
    linkData:
        [
            { type: 'github', url: "https://github.com/lucasctnh/gdstd-1-unity" },
            { type: 'text', url: "https://play.unity.com/pt/games/cf44b639-2185-4618-9965-7c1a9f0d275b/gdstd-prototype-1" },
        ],
    relatedProjects: ["GDSTD2", "GDSTD3", "CheckMore"],
};


export function GDSTD1() {
    return (
        <div>
            <ProjectBase project={projectDetails}
                useCarousel={false}
                isLeftFirst={false}
                leftContent={
                    <Col size={12} md={12} className="a-body-left" style={{ marginTop: "0" }}>
                        <div className="a-subtitle">
                            Afterthoughts
                        </div>

                        <div className="a-body-description">
                            {renderTextBlock(`I wanted to test out Unity's URP render pipeline because I was having some performance issues on my last project and I thought URP could help with this. And, well, I think it definitely helps but I can't say for sure by how much because the circumstances were quite different.

Furthermore, when I finished this prototype I realized doing this type of project where you focus solely on what you want to learn helps a lot and it is actually pretty relaxing too haha 😆. So I decided to do a lot more of these whenever I feel I need to learn something specific.`)}
                        </div>
                    </Col>
                }
                rightContent={
                    null
                } >
            </ProjectBase >
        </div >
    );
}